import { LoaderFunction } from 'react-router-dom';

import { fetchGraphQL } from 'src/services/contentful/client';
import { ContentHubType } from 'src/constants';
import { isPreviewMode } from 'src/utils/isPreviewMode';
import {
  ContentfulFlexibleContentHub,
  GET_FLEXIBLE_CONTENT_HUB_COLLECTION,
  GetFlexibleContentHubCollectionResponse,
} from 'src/graphql/queries/GetFlexibleContentHub';
import { GetFlexibleContentHubCollectionQueryVariables } from 'src/graphql/generated/GetFlexibleContentHub';

export interface DynamicHubLoaderProps {
  dynamicHubData: ContentfulFlexibleContentHub;
}

const getDynamicHubData = async (
  type: string,
  slug: string,
  preview: boolean,
): Promise<ContentfulFlexibleContentHub | undefined> => {
  const response = await fetchGraphQL<
    GetFlexibleContentHubCollectionResponse,
    GetFlexibleContentHubCollectionQueryVariables
  >(GET_FLEXIBLE_CONTENT_HUB_COLLECTION, {
    preview,
    type,
    slug,
  });

  return response.flexibleContentHubCollection.items[0];
};

export const loader: LoaderFunction = async ({ params }): Promise<DynamicHubLoaderProps> => {
  const preview = isPreviewMode();
  const { slug } = params;

  if (!slug) {
    throw new Error('Hub slug is required');
  }

  const dynamicHubData = await getDynamicHubData(ContentHubType.DYNAMIC, slug, preview);

  if (!dynamicHubData) {
    throw new Error(`Hub for "${slug}" was not found`);
  }

  return { dynamicHubData };
};
